import { Grid, Typography } from '@mui/material';

const DetailItem: React.FC<{ icon: React.ReactNode; label: string; children: React.ReactNode }> = ({
  icon,
  label,
  children,
}) => (
  <Grid container alignItems="flex-start" mb={2}>
    <Grid sx={{ color: 'text.secondary', mr: 2, mt: 0.5 }}>{icon}</Grid>
    <Grid flexGrow={1}>
      <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', fontWeight: 'bold' }}>
        {label}
      </Typography>
      {children}
    </Grid>
  </Grid>
);

export default DetailItem;
